var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1539_610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.763 12.3233L9.82188 1.09526C9.64629 0.76454 9.38393 0.487858 9.06296 0.294903C8.742 0.101947 8.37453 0 8 0C7.62547 0 7.258 0.101947 6.93704 0.294903C6.61607 0.487858 6.35371 0.76454 6.17812 1.09526L0.236992 12.3233C0.0717613 12.6365 -0.00957277 12.9872 0.000896989 13.3413C0.0113667 13.6953 0.113284 14.0406 0.296741 14.3435C0.480197 14.6465 0.738951 14.8969 1.04785 15.0703C1.35674 15.2438 1.70527 15.3343 2.05954 15.3333H13.9405C14.2947 15.3343 14.6433 15.2438 14.9522 15.0703C15.261 14.8969 15.5198 14.6465 15.7033 14.3435C15.8867 14.0406 15.9886 13.6953 15.9991 13.3413C16.0096 12.9872 15.9282 12.6365 15.763 12.3233ZM8 13.3333C7.80216 13.3333 7.60876 13.2746 7.44426 13.1647C7.27976 13.0548 7.15155 12.8987 7.07584 12.7159C7.00013 12.5332 6.98032 12.3321 7.01892 12.1382C7.05752 11.9442 7.15278 11.766 7.29268 11.6262C7.43257 11.4863 7.61081 11.3911 7.80485 11.3525C7.99889 11.3139 8.20002 11.3337 8.3828 11.4094C8.56558 11.4851 8.72181 11.6132 8.83172 11.7777C8.94164 11.9421 9.0003 12.1355 9.0003 12.3333C9.0003 12.5985 8.89491 12.8528 8.70732 13.0404C8.51973 13.2279 8.2653 13.3333 8 13.3333ZM8.66687 9.99993H7.33313L6.9997 4.66659H9.0003L8.66687 9.99993Z",
    fill: "#FF7A00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1539_610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.eaaa7ab03367adbcf7668c4851c35607.svg";
export { ForwardRef as ReactComponent };